(() => {
  angular
    .module('app')
    .controller('host.views.corporates.supportPlan.index', SupportPlanPageController);

  SupportPlanPageController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$filter',
    'abp.services.app.supportPlan',
    'Hms.SupportPlans.SupportPlan',
    'abp.services.app.commonLookup',
  ];

  function SupportPlanPageController(
    $scope,
    $state,
    $stateParams,
    $filter,
    supportPlanSvc,
    constsSupportPlan,
    commonLookupSvc
  ) {
    const ccyFilter = $filter('currencyFormat');
    const inpatientDetails = [
      new TreatmentModel(251, App.localize('Hospitalization'), 'fas fa-bed', true),
    ];

    const vm = this;
    vm.constsSupportPlan = constsSupportPlan;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.supportPlanId = $stateParams.supportPlanId;
    vm.corporateId = $stateParams.organizationId;
    vm.isInpatient = $stateParams.isInpatient;
    vm.loading = 0;
    vm.saving = 0;
    vm.isCreate = !vm.supportPlanId;
    vm.buttonLabel = vm.isCreate ? App.localize('Save') : App.localize('Update');

    function init() {
      getSupportPlan();
      getCountryAndCurrency();
    }

    function getSupportPlan() {
      vm.loading += 1;
      supportPlanSvc
        .getSupportPlanForEdit({
          id: vm.supportPlanId,
          corporateId: vm.corporateId,
        })
        .success((data) => {
          vm.supportPlan = new SupportPlanModel(data);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getCountryAndCurrency() {
      vm.loading += 1;
      commonLookupSvc
        .getCountryAndCurrencyByTenantId({ tenantId: vm.corporateId})
        .success((data) => {
          if (data.currency.code) vm.currencyCode = data.currency.code;
          if (data.countryCode) vm.countryCode = data.countryCode;
          vm.costSharingExample = App.localize('CostSharingExample', vm.currencyCode);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    vm.submit = () => {
      vm.saving = true;
      supportPlanSvc
        .createOrUpdateSupportPlan(vm.supportPlan.toDto())
        .success(() => {
          abp.notify.info(App.localize('SuccessfullySaved'));
          $state.go('host.corporateSupportPlans', { id: vm.corporateId });
        })
        .finally(() => {
          vm.saving = false;
        });
    };

    function automap(source, target) {
      _.forIn(source, (v, k) => {
        target[k] = source[k];
      });
    }

    function SupportPlanModel(dto) {
      // Basic properties

      this.id = 0;
      this.tenantId = vm.corporateId;
      this.planName = '';
      this.displayName = '';
      this.remarks = '';

      // Benefits

      this.hasDependentCovered = 1;
      this.principal = inpatientDetails;
      this.dependent = inpatientDetails;

      // Benefit Modifiers

      this.modifiers = [];

      // Benefit summaries

      this.principalSummaries = [];
      this.showPrincipalFootnote = false;
      this.dependentSummaries = [];
      this.showDependentFootnote = false;

      // Functions

      this.addModifier = () => {
        const modifier = new Modifier(this);
        vm.supportPlan.modifiers.push(modifier);
      };

      this.removeModifier = (index) => {
        abp.message.confirm(
          App.localize('DeleteBenefitModifierWarningMessage'),
          App.localize('AreYouSure'),
          (d) => {
            if (d) {
              $scope.$apply(() => {
                vm.supportPlan.modifiers.splice(index, 1);
                this.refreshResult();
              });
              return true;
            }
            return false;
          }
        );
      };

      this.refreshResult = () => {
        const principalSummaries = [];
        const dependentSummaries = [];
        let showPrincipalFootnote = false;
        let showDependentFootnote = false;

        let coverDependent = !!this.hasDependentCovered;
        const principal = _.map(
          _.filter(this.principal, 'valid'),
          (x) => new BenefitResult(x, true, true)
        );
        const dependent = coverDependent
          ? _.map(_.filter(this.dependent, 'valid'), (x) => new BenefitResult(x, true, true))
          : [];
        if (!dependent.length) {
          coverDependent = false;
        }
        const coverPrincipal = principal.length > 0;

        // Group result into stacks

        _.each(this.modifiers, (mod) => {
          if (mod.cycle === 4 && mod.type !== 0) {
            mod.cycle = 3;
          }
        });

        _.each(
          _.groupBy(this.modifiers, (x) => {
            const interval = x.cycle === 0 ? x.interval : 1;
            return `${x.type}:${interval}:${x.cycle}`;
          }),
          (values) => {
            _.each(values, (modifier) => {
              const applicableTreatments = _.filter(modifier.treatments, (x) => x.applicable);
              const principalPortion = [];
              const dependentPortion = [];

              const beneficiary = coverDependent ? modifier.beneficiary : 1;
              let poolMode = coverDependent ? modifier.poolMode : 2;

              const includesPrincipal = [1, 3].includes(beneficiary);
              const includesDependent = [2, 3].includes(beneficiary);

              _.each(applicableTreatments, (t) => {
                let benefit;
                if (coverPrincipal && (beneficiary && includesPrincipal) > 0) {
                  benefit = _.find(principal, (x) => x.treatment.id === t.treatment.id);
                  if (benefit) {
                    if (modifier.type === 0) {
                      benefit.unlimitedBudget = false;
                    } else if (modifier.type === 1) {
                      benefit.unlimitedVisit = false;
                    }
                    principalPortion.push(t.treatment);
                  }
                }
                if (coverDependent && (beneficiary && includesDependent) > 0) {
                  benefit = _.find(dependent, (x) => x.treatment.id === t.treatment.id);
                  if (benefit) {
                    if (modifier.type === 0) {
                      benefit.unlimitedBudget = false;
                    } else if (modifier.type === 1) {
                      benefit.unlimitedVisit = false;
                    }
                    dependentPortion.push(t.treatment);
                  }
                }
              });

              if (principalPortion.length || dependentPortion.length) {
                const uniquePortion = _.uniqBy(_.concat(principalPortion, dependentPortion), 'id');
                const modifierTreatmentNames = _.join(_.map(uniquePortion, 'name'), '+');
                const principalTreatmentNames = _.join(_.map(principalPortion, 'name'), '+');
                const dependentTreatmentNames = _.join(_.map(dependentPortion, 'name'), '+');

                if (poolMode === 0 && (!principalPortion.length || !dependentPortion.length)) {
                  poolMode = 2;
                }

                let principalSummaryRecord = null;
                if (principalTreatmentNames) {
                  principalSummaryRecord = _.find(
                    principalSummaries,
                    (x) => x.key === principalTreatmentNames
                  );

                  if (!principalSummaryRecord) {
                    principalSummaries.push(
                      (principalSummaryRecord = new BenefitSummary(principalTreatmentNames))
                    );
                  }
                }

                let dependentSummaryRecord = null;
                if (dependentTreatmentNames) {
                  dependentSummaryRecord = _.find(
                    dependentSummaries,
                    (x) => x.key === dependentTreatmentNames
                  );

                  if (!dependentSummaryRecord) {
                    dependentSummaries.push(
                      (dependentSummaryRecord = new BenefitSummary(dependentTreatmentNames))
                    );
                  }
                }

                // Get modifier description

                let str = '';
                const strValue = _.isNil(modifier.value) ? '?' : modifier.value;
                switch (modifier.type) {
                  case 0:
                    str += ` ${ccyFilter(modifier.value, vm.currencyCode)}`;
                    break;
                  case 1:
                    str += ` ${strValue} ${App.localize('VisitLimit').toLowerCase()}`;
                    break;
                  case 2:
                    str += ` ${ccyFilter(modifier.value, vm.currencyCode)} (${App.localize(
                      'BudgetOverdraft'
                    ).toLowerCase()})`;
                    break;
                  case 3:
                    str += ` ${strValue}${App.localize('VisitOverdraft').toLowerCase()}`;
                    break;
                  default:
                    break;
                }

                let cycle = '';
                switch (modifier.cycle) {
                  case 0:
                    cycle = App.localize('EveryXYears', modifier.interval).toLowerCase();
                    break;
                  case 1:
                    cycle = App.localize('Annually').toLowerCase();
                    break;
                  case 2:
                    cycle = App.localize('Monthly').toLowerCase();
                    break;
                  case 3:
                    cycle = App.localize('Daily').toLowerCase();
                    break;
                  case 4:
                    cycle = App.localize('PerVisit').toLowerCase();
                    break;
                  case 5:
                    cycle = App.localize('Every6Months').toLowerCase();
                    break;
                  case 6:
                    cycle = App.localize('Every4Months').toLowerCase();
                    break;
                  case 7:
                    cycle = App.localize('Every3Months').toLowerCase();
                    break;
                  case 8:
                    cycle = App.localize('Every2Months').toLowerCase();
                    break;
                  default:
                    break;
                }
                str += ` ${cycle}`;

                let allStr;
                let principalStr;
                let dependentStr;

                if (poolMode === 0) {
                  allStr = str;
                  if (principalTreatmentNames !== dependentTreatmentNames) {
                    if (principalPortion.length) {
                      allStr += ` (${App.localize('Principal')}: ${principalTreatmentNames})`;
                    }
                    if (dependentPortion.length) {
                      allStr += ` (${App.localize('Dependent')}: ${dependentTreatmentNames})`;
                    }
                  }

                  if (principalSummaryRecord) {
                    principalSummaryRecord.addItem(
                      modifier.type,
                      cycle,
                      '[1]',
                      modifier.value || 0
                    );
                    showPrincipalFootnote = true;
                  }
                  if (dependentSummaryRecord) {
                    dependentSummaryRecord.addItem(
                      modifier.type,
                      cycle,
                      '[1]',
                      modifier.value || 0
                    );
                    showDependentFootnote = true;
                  }
                } else if (poolMode === 1) {
                  principalStr = '';
                  if (principalPortion.length) {
                    principalStr = str;
                    if (principalTreatmentNames !== modifierTreatmentNames) {
                      principalStr += ` (${principalTreatmentNames})`;
                    }
                  }

                  dependentStr = '';
                  if (dependentPortion.length) {
                    dependentStr = str;
                    if (dependentTreatmentNames !== modifierTreatmentNames) {
                      dependentStr += ` (${dependentTreatmentNames})`;
                    }
                  }

                  if (principalSummaryRecord) {
                    principalSummaryRecord.addItem(modifier.type, cycle, '', modifier.value || 0);
                  }
                  if (dependentSummaryRecord) {
                    dependentSummaryRecord.addItem(modifier.type, cycle, '', modifier.value || 0);
                  }
                } else if (poolMode === 2) {
                  principalStr = '';
                  if (principalPortion.length) {
                    principalStr = str;
                    if (principalTreatmentNames !== modifierTreatmentNames) {
                      principalStr += ` (${principalTreatmentNames})`;
                    }
                  }

                  dependentStr = '';
                  if (dependentPortion.length) {
                    dependentStr = str;
                    if (dependentTreatmentNames !== modifierTreatmentNames) {
                      dependentStr += ` (${dependentTreatmentNames})`;
                    }
                  }

                  if (principalSummaryRecord) {
                    principalSummaryRecord.addItem(modifier.type, cycle, '', modifier.value || 0);
                  }
                  if (dependentSummaryRecord) {
                    dependentSummaryRecord.addItem(
                      modifier.type,
                      cycle,
                      '[2]',
                      modifier.value || 0
                    );
                    showDependentFootnote = true;
                  }
                }
              }
            });
          }
        );

        // Print summary

        principal.forEach((x) => {
          if (x.unlimitedVisit || x.unlimitedBudget) {
            let summary = _.find(principalSummaries, (y) => y.key === x.treatment.name);
            if (!summary) {
              principalSummaries.push((summary = new BenefitSummary(x.treatment.name)));
            }

            if (x.unlimitedBudget && x.unlimitedVisit) {
              summary.addText(App.localize('Unlimited'));
            } else {
              if (x.unlimitedBudget) {
                summary.addText(App.localize('UnlimitedBudget'));
              }
              if (x.unlimitedVisit) {
                summary.addText(App.localize('UnlimitedVisit'));
              }
            }
          }
        });
        this.principalSummaries = principalSummaries;
        this.showPrincipalFootnote = showPrincipalFootnote;

        dependent.forEach((x) => {
          if (x.unlimitedVisit || x.unlimitedBudget) {
            let summary = _.find(dependentSummaries, (y) => y.key === x.treatment.name);
            if (!summary) {
              dependentSummaries.push((summary = new BenefitSummary(x.treatment.name)));
            }
            if (x.unlimitedBudget && x.unlimitedVisit) {
              summary.addText(App.localize('Unlimited'));
            } else {
              if (x.unlimitedBudget) {
                summary.addText(App.localize('UnlimitedBudget'));
              }
              if (x.unlimitedVisit) {
                summary.addText(App.localize('UnlimitedVisit'));
              }
            }
          }
        });
        this.dependentSummaries = dependentSummaries;
        this.showDependentFootnote = showDependentFootnote;
      };

      // Initialization

      if (dto) {
        automap(dto, this);

        this.principal = inpatientDetails;
        this.dependent = inpatientDetails;
        this.hasDependentCovered = vm.isCreate || dto.hasDependentCovered ? 1 : 0;
        this.modifiers = [];
        _.each(dto.modifiers, (x) => {
          this.modifiers.push(new Modifier(this, x));
        });
      }

      this.refreshResult();

      // Post method

      this.toDto = () => {
        function getModifierDto(modifiers) {
          return _(modifiers)
            .map((m) => m.toDto())
            .value();
        }

        return {
          id: this.id,
          tenantId: this.tenantId,
          planName: this.planName,
          displayName: this.displayName,
          remarks: this.remarks,
          hasDependentCovered: this.hasDependentCovered,
          modifiers: getModifierDto(this.modifiers),
        };
      };
    }

    function TreatmentModel(id, name, icon, valid) {
      this.id = id;
      this.name = name;
      this.icon = icon;
      this.valid = valid;
    }

    function TreatmentApplyModel(treatment, applicable) {
      this.treatment = treatment;
      this.applicable = applicable;
    }

    function BenefitResult(treatment, unlimitedBudget, unlimitedVisit) {
      this.treatment = treatment;
      this.unlimitedBudget = unlimitedBudget;
      this.unlimitedVisit = unlimitedVisit;
    }

    function BenefitSummaryItem(type, cycle, poolMode, value) {
      this.type = type;
      this.cycle = cycle;
      this.poolMode = poolMode;
      this.value = value;

      this.toString = () => {
        let str = '';
        const strValue = _.isNil(this.value) ? '?' : this.value;
        switch (this.type) {
          case 0:
            str += `RM${strValue}`;
            break;
          case 1:
            str += `${strValue} ${this.value > 1 ? 'visits' : 'visit'}`;
            break;
          case 2:
            str += `RM${strValue} overdraft`;
            break;
          case 3:
            str += `${strValue} overdraft ${this.value > 1 ? 'visits' : 'visit'}`;
            break;
          default:
            break;
        }

        str += ` ${this.cycle} ${this.poolMode}`;
        return str;
      };
    }

    function BenefitSummary(key, value) {
      this.items = [];
      this.texts = [];

      this.key = key;
      this.value = value;

      this.addItem = (type, cycle, poolMode, itemValue) => {
        const item = _.find(
          this.items,
          (x) => x.type === type && x.cycle === cycle && x.poolMode === poolMode
        );

        if (!item) {
          this.items.push(new BenefitSummaryItem(type, cycle, poolMode, value));
        } else {
          item.value += itemValue;
        }
      };

      this.addText = (text) => {
        this.texts.push(text);
      };

      this.toString = () =>
        _.concat(
          _.map(this.items, (x) => x.toString()),
          this.texts
        ).join(', ');
    }

    function Modifier(bgModel, dto) {
      this.parent = bgModel;

      // Basic properties

      this.type = 0;
      this.cycle = 1;
      this.beneficiary = 3;
      this.poolMode = 0;
      this.value = null;
      this.interval = 2;

      // View properties

      this.show = true;
      this.description = '';

      // Treatment type mapping

      this.principalMap = _.keyBy(bgModel.principal, 'id');
      this.dependentMap = _.keyBy(bgModel.dependent, 'id');

      // Applicable treatment types

      const treatments = [];
      _.each(this.parent.principal, (e) => {
        const isValid = checkValid(e.id);
        treatments.push(
          new TreatmentApplyModel(new TreatmentModel(e.id, e.name, e.icon, isValid), isValid)
        );
      });
      this.treatments = treatments;

      // Private functions

      function checkValid(id) {
        switch (this.beneficiary) {
          case 3:
            return (
              this.principalMap[id].valid ||
              (this.parent.hasDependentCovered === 1 && this.dependentMap[id].valid)
            );
          case 1:
            return this.principalMap[id].valid;
          case 2:
            return this.dependentMap[id].valid;
          default:
            return false;
        }
      }

      function validateModifierRules() {
        // If modifier is not budget limit, cycle cannot be Per Visit.
        // Default to annually.

        if (this.type !== 0 && this.cycle === 4) {
          this.cycle = 1;
        }

        // If beneficiary is principal only, there is no pool to share.
        // If beneficiary is dependant only, split pool cannot be selected.
        // Default to individual pool.

        if (this.beneficiary === 1 || (this.beneficiary === 2 && this.poolMode === 2)) {
          this.poolMode = 1;
        }
      }

      // Public functions

      this.changed = () => {
        validateModifierRules();
        this.refreshTreatmentValidity();
        this.refreshDescription();
      };

      this.refreshTreatmentValidity = () => {
        _.each(this.treatments, (e) => {
          e.treatment.valid = checkValid(e.treatment.id);
        });
      };

      // Post method

      this.toDto = () => ({
        type: this.type,
        cycle: this.cycle,
        beneficiary: this.beneficiary,
        poolMode: this.poolMode,
        value: this.value,
        interval: this.interval,
        affectedBenefits: _(treatments).filter('applicable').map('treatment.id').value(),
      });

      this.refreshDescription = () => {
        const { type } = this;
        const { cycle } = this;
        const { interval } = this;
        const { beneficiary } = this;
        const { poolMode } = this;
        const { value } = this;
        const { treatmentTypes } = this;
        let desc = '';
        const ttNames = [];

        switch (cycle) {
          case 0:
            desc += `Every ${interval} year(s)`;
            break;
          case 1:
            desc += 'Every year';
            break;
          case 2:
            desc += 'Every month';
            break;
          case 3:
            desc += 'Everyday';
            break;
          case 4:
            desc += 'Every visit';
            break;
          default:
            break;
        }

        switch (type) {
          case 0:
          case 1:
            desc += ' limits ';
            break;
          case 2:
          case 3:
            desc += ' allows overdraft of ';
            break;
          default:
            break;
        }

        switch (type) {
          case 0:
          case 2:
            desc += `${vm.currencyCode} ${value}`;
            break;
          case 1:
          case 3:
            desc += `${value} visits`;
            break;
          default:
            break;
        }

        switch (beneficiary) {
          case 1:
            desc += ' for principal';
            break;
          case 2:
            desc += ' for dependants';
            break;
          case 3:
            desc += ' for principal & dependants';
            break;
          default:
            break;
        }

        switch (poolMode) {
          case 0:
            desc += ' where everyone share';
            break;
          case 1:
            desc += ' individually';
            break;
          case 2:
            desc += ' where dependents share';
            break;
          default:
            break;
        }

        if (treatmentTypes) {
          desc += ' on ';

          _.each(treatmentTypes, (isApplied, idStr) => {
            const id = parseInt(idStr, 10);
            if (isApplied) {
              ttNames.push(_.find(vm.treatmentTypes, (a) => a.id === id).name);
            }
          });

          desc += ttNames.join(', ');
        }

        this.description = ttNames.length > 0 ? desc : 'Not applicable';
      };

      // Initialization

      if (dto) {
        automap(dto, this);
        _.each(this.treatments, (x) => {
          x.applicable = _.indexOf(dto.affectedBenefits, x.treatment.id) >= 0;
        });
        this.refreshTreatmentValidity();
      }

      this.refreshDescription();
    }

    /* End of Types */

    vm.beneficiary = {
      principal: 1,
      dependent: 2,
    };

    init();
  }
})();
